<template lang="pug">
  #poll-view.body: .body-inner
    Simplebar(data-simplebar-auto-hide="false" class="body-simplebar")
      PollQuestion(
        v-for="({ id, idx, answers }, index) in filteredQuestions"
        :key="id"
        :id="id"
        :idx="idx"
        :answers="answers"
        :total="questionsTotalCount"
      )
</template>

<script>
import store from '@/store'
import Simplebar from 'simplebar-vue'
import PollQuestion from './PollQuestion'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Poll',
  // Components ----------------------------------------------------------------
  components: {
    Simplebar,
    PollQuestion
  },
  // Before route enter ------------------------------------------------- [Hook]
  async beforeRouteEnter (to, from, next) {
    const answers = store.state.moduleUser.poll.answers
    if (from.name === 'deposit') {
      if (answers.length > 0) store.commit('moduleUser/SET_POLL_DEFAULTS', answers.length)
      return next()
    }
    const { status, errors } = await store.dispatch('moduleUser/fetchPollQuestions')
    if (status) {
      next()
    } else {
      store.commit('moduleWizard/SET_NAV_FIELD', { f: 'errorTextNext', v: errors.global[0] })
    }
  },
  // Created ------------------------------------------------------------ [Hook]
  created () {
    this.SET_CURRENT_VIEW({ vm: this })
  },
  // Data ----------------------------------------------------------------------
  data () {
    return {
      currentQuestionIdx: 0 // current question idx
    }
  },
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the User SM
    ...mapGetters('moduleUser', [
      'getPollQuestionsModels'
    ]),
    // Questions count
    questionsTotalCount () {
      return this.getPollQuestionsModels.length
    },
    // Filtered questions
    filteredQuestions () {
      return this.getPollQuestionsModels.filter((q) => q.idx === this.currentQuestionIdx)
    },
    // Robot message
    robotMessage () {
      return `<span class="ahl">Вопрос ${this.currentQuestionIdx + 1} из ${this.questionsTotalCount}:</span> ${this.filteredQuestions[0].text}`
    }
  },
  // Methods -------------------------------------------------------------------
  methods: {
    // Vuex map mutations of the Wizard SM
    ...mapMutations('moduleWizard', [
      'SET_CURRENT_VIEW',
      'SET_NAV_FIELD'
    ]),
    // Vuex map actions of the User SM
    ...mapActions('moduleUser', [
      'sendPollAnswers'
    ]),
    // Vuex map actions of the Security SM
    ...mapActions('moduleSecurity', [
      'sendMessage'
    ]),
    // Self back validator
    backSelf () {
      if (this.currentQuestionIdx === 0) {
        this.SET_NAV_FIELD({ f: 'disableNext', v: false }) // disabled status of the next btn
        return true
      }
      this.currentQuestionIdx--
      return false
    },
    // Self next validator
    async nextSelf () {
      if (this.currentQuestionIdx < this.questionsTotalCount - 1) {
        this.currentQuestionIdx++
        return false
      }
      const { status, errors } = await this.sendPollAnswers()
      if (status) {
        this.sendMessage({ e: 'PollComplete' })
        return true
      }
      this.SET_NAV_FIELD({ f: 'errorTextNext', v: errors.global[0] })
      return status
    }
  }
}
</script>
